<template>
  <MainWrapper>
    <div class="single-master-page">
      <div class="container">
        <div class="row">
          <div class="col-lg-3">
            <div class="spec-info">
              <div class="mb-30">
                <div class="spec-links">
                  <router-link
                    v-if="specInfo.service.length > 0"
                    class="spec-link block mb-5"
                    :to="`/masters/${$route.params.slug}/pricelist`"
                  >Прайс-лист</router-link>
                  <router-link
                    v-else
                    class="spec-link block mb-5"
                    to
                    style="background:#cccccc"
                  >Прайс-лист</router-link>
                  <router-link class="spec-link block" to>Акции и скидки</router-link>
                </div>
                <div
                  v-if="specInfo.photo"
                  class="spec-img"
                  :style="{'background-image': `url(${specInfo.photo})`}"
                ></div>
                <div v-else class="spec-img"></div>
              </div>
              <h3 class="mb-10">{{ specInfo.full_name }}</h3>
              <div class="rating-wrapper mb-20">
                <span>Рейтинг ({{ specInfo.rating | rating }})</span>
                <star-rating
                  class="ml-10"
                  :rating="this.specInfo.rating"
                  :increment="0.01"
                  :star-size="20"
                  :read-only="true"
                  :show-rating="false"
                ></star-rating>
              </div>
              <span class="dark-body-text block mb-10">{{ specInfo.categories[0].name }}</span>
              <p v-html="specInfo.short_info" class="gray-body-text mb-15"></p>
              <div v-if="specInfo.calendar > 0" class="spec-state mb-30">
                <div class="state-circle mr-5" :class="{'state-circle-red': !specInfo.opened_now}"></div>
                <span>{{ specInfo.opened_now ? 'Свободен' : 'Не свободен'}}</span>
              </div>
              <div class="gray-line mb-30"></div>
              <div v-if="specInfo.company">
                <div
                  v-for="com, i in specInfo.company"
                  :key="i"
                  class="mb-20"
                  :style="'padding-left:10px;border-left:5px solid '+zcolors[com.owner]"
                >
                  <router-link :to="com.url">
                    <!--<p>{{ com.name }}</p>-->
                    <!--<p>{{ com.street_address.replace(/:::::/g, ", ") }}</p>-->
                    <div class="mb-10">
                      <font-awesome-icon
                        class="geo-icon mr-5"
                        :icon="['fal', 'building']"
                        style="display:inline-block;width:18px;height:18px;color:#2b2b2b"
                      />
                      <span>{{ com.name }}</span>
                    </div>
                    <div>
                      <font-awesome-icon
                        class="geo-icon mr-5"
                        :icon="['fal', 'map-marker-alt']"
                        style="display:inline-block;width:18px;height:18px;color:#24ceda"
                      />
                      <span>{{ com.street_address.replace(/:::::/g, ", ") }}</span>
                    </div>
                  </router-link>
                </div>
              </div>
              <h3>Контакты:</h3>
              <div v-if="specInfo.phones" class="phones mt-5 mb-10">
                <div v-for="(p,i) in specInfo.phones" :key="i">
                  <a :href="`tel:${p}`" v-text="p"></a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-9">
            <div v-if="specInfo.company.length > 1" class="single-master-filters mb-30">
              <div v-for="com, i in specInfo.company" :key="i" class="mr-20">
                <div
                  class="checkbox mr-10"
                  :class="{ pressed: com.checked }"
                  @click="com.checked = !com.checked"
                >
                  <font-awesome-icon class="checkbox-check" :icon="['fal', 'check']" />
                </div>
                <span>{{ com.name }}</span>
              </div>
            </div>
            <div class="schedule-controls mb-20" v-if="isVisible">
              <div
                class="button-left animated-shadow pointer round-button mr-10 mobile-ctrl"
                @click="prevDay"
              >
                <font-awesome-icon class="icon" :icon="['fal', 'angle-left']" />
              </div>
              <div
                class="button-right animated-shadow pointer round-button mr-30 mobile-ctrl"
                @click="nextDay"
              >
                <font-awesome-icon class="icon" :icon="['fal', 'angle-right']" />
              </div>
              <div
                class="button-left animated-shadow pointer round-button mr-10 pc-ctrl"
                @click="prevWeek"
              >
                <font-awesome-icon class="icon" :icon="['fal', 'angle-left']" />
              </div>
              <div
                class="button-right animated-shadow pointer round-button mr-30 pc-ctrl"
                @click="nextWeek"
              >
                <font-awesome-icon class="icon" :icon="['fal', 'angle-right']" />
              </div>
              <div class="input-wrapper" style="width:170px">
                <input
                  v-model="teleportDay"
                  @change="teleportSetTime"
                  type="date"
                  class="rounded-input"
                  placeholder="Переход на точную дату"
                />
              </div>
              <!--
                        <div class="live-query-button-wrapper">
                            <Button text="Живая очередь" />
                        </div>
              -->
            </div>
            <div v-else class="schedule-controls mb-20 no-calendar">
              <span>У специалиста не настроена функция онлайн записи</span>
              <div class="mt-10" v-if="isCurrentUser">
                <router-link to="/specialist/settings/schedule">
                  <Button type="primary" text="Настроить" />
                </router-link>
              </div>
            </div>
            <div class="white-panel mb-10 schedule-panel" v-if="isVisible">
              <Schedule
                ref="calendar"
                :services="specInfo.service"
                :slug="$route.params.slug"
                :specialist="specInfo"
                :startDate="firstDay"
              />
            </div>
            <div class="white-panel spec-deep-info">
              <div class="container-fluid">
                <div class="row">
                  <div class="tabs mb-30">
                    <div
                      class="tab pb-15 mr-30 inline-block pointer"
                      :class="{ active: tab === 1 }"
                      @click="tab = 1"
                    >
                      <h4>Информация</h4>
                    </div>
                    <div
                      class="tab pb-15 mr-30 inline-block pointer"
                      :class="{ active: tab === 2 }"
                      @click="tab = 2"
                    >
                      <h4>Отзывы ({{ total }})</h4>
                    </div>
                    <div class="light-gray-line"></div>
                  </div>
                </div>
                <div v-if="tab === 2 && specReviews.length > 0" class="row mb-15">
                  <div v-for="(review,i) in specReviews" :key="i" class="col-lg-8 no-p mb-15">
                    <span class="dark-body-text block mb-10 reviewer-name">
                      {{ review.full_name }}
                      <star-rating
                        :rating="review.rating"
                        :increment="1"
                        :star-size="15"
                        :read-only="true"
                        :show-rating="false"
                        class="review-star"
                      ></star-rating>
                    </span>
                    <p class="mb-10">{{ review.message }}</p>
                    <p style="color:#828282">{{ review.created_at }}</p>
                  </div>
                </div>
                <div class="row" v-if="tab === 2">
                  <div class="col-lg-12">
                    <Paginator
                      :pages="pages"
                      v-if="pages > 1"
                      :current="page"
                      @change-page="changePage"
                    />
                  </div>
                </div>
                <div v-if="tab === 2" class="row mb-30">
                  <div class="col-lg-8 no-p">
                    <span class="dark-body-text block mb-10">Оставить отзыв</span>
                    <textarea
                      v-model="comment"
                      style="width:600px;height:160px;border-radius:8px;border:1px solid #E0E0E0"
                    ></textarea>
                    <span class="dark-body-text block mt-15 mb-10">Дайте свою оценку специалисту</span>
                    <RatingStar
                      :title="workQualityTitle"
                      :significant="true"
                      :rating="this.rateState.work.rating"
                      :isEmpty="this.rateState.work.isEmpty"
                      @setRate="workQualityHandler"
                    />
                    <RatingStar
                      :title="serviceQualityTitle"
                      :significant="true"
                      :rating="this.rateState.service.rating"
                      :isEmpty="this.rateState.service.isEmpty"
                      @setRate="serviceQualityHandler"
                    />
                    <RatingStar
                      :title="paymentQualityTitle"
                      :significant="false"
                      :rating="this.rateState.payment.rating"
                      :isEmpty="this.rateState.payment.isEmpty"
                      @setRate="paymentQualityHandler"
                    />
                    <div class="button-wrapper mt-30">
                      <Button type="gray" text="Сохранить" @click="setComment" />
                    </div>
                  </div>
                </div>
                <div v-if="tab === 1" v-for="com, i in specInfo.company" :key="i" class="row mb-30">
                  <div class="col-lg-8 no-p">
                    <span class="dark-body-text block mb-10">{{com.name}}</span>
                    <p v-html="com.short_info"></p>
                  </div>
                </div>
                <div v-if="tab === 1" class="row mb-30">
                  <div class="col-lg-8 no-p">
                    <span class="dark-body-text block mb-10">О специалисте</span>
                    <p v-html="specInfo.full_info"></p>
                  </div>
                </div>
                <div
                  v-if="tab === 1 && specInfo.specialist_certificate.length > 0"
                  class="row mb-30"
                >
                  <div class="col-lg-12 no-p">
                    <span class="dark-body-text block mb-10">Сертификаты</span>
                    <div class="mb-15">
                      <div
                        class="mr-15"
                        v-for="s,i in specInfo.specialist_certificate"
                        :key="i"
                        style="display:inline-block"
                      >
                        <a :href="s.url" target="_blank">
                          <img style="height:170px" :src="s.url" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="tab === 1 && specInfo.specialist_portfolio.length > 0" class="row mb-30">
                  <div class="col-lg-12 no-p">
                    <span class="dark-body-text block mb-10">Портфолио</span>
                    <div class="mb-15">
                      <div
                        class="mr-15"
                        v-for="p,i in specInfo.specialist_portfolio"
                        :key="i"
                        style="display:inline-block"
                      >
                        <a :href="p.url" target="_blank">
                          <img style="height:170px" :src="p.url" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </MainWrapper>
</template>
<style lang="stylus" scoped>
@import '../../styles/main.core.vars.styl';

.rating-wrapper {
  display: flex;
  align-items: center;
}

.spec-img {
  background: #fff;
  width: 100px;
  height: 100px;
  border-radius: 100%;
  background-size: cover;
  background-position: center;
  border: 5px solid #fff;
  position: relative;
}

.spec-deep-info {
  padding: 20px;
  overflow: hidden;
}

// .schedule-panel
// overflow: hidden
.single-master-filters {
  display: flex;
  align-items: center;

  >div {
    display: flex;
    align-items: center;
  }
}

.schedule-controls-mobile {
  display: none;
  align-items: center;
}

.schedule-controls {
  display: flex;
  align-items: center;

  .live-query-button-wrapper {
    margin: 0 0 0 auto;
  }
}

.input-wrapper {
  input {
    padding: 10px 15px;
  }
}

.spec-links {
  position: absolute;
  top: 9px;
  left: 75px;

  .spec-link {
    background: cyan_dark_color;
    color: #fff;
    border-radius: 4px;
    width: 147px;
    padding: 13px 0 13px 45px;
    font-size: 10px;
    transition: 0.3s;

    &:hover {
      transform: translateX(5px);
    }
  }
}

.mobile-ctrl {
  display: none;
}

.no-calendar {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 15px;
  padding: 15px;
  border-radius: 15px;
  background: linear-gradient(270deg, #1BEFDC 0%, #24CEDA 100%);
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  color: #fff;
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 16px;
}

.reviewer-name {
  display: flex;
  flex-direction: row;
}

.review-star {
  margin-left: 10px;
}

@media (max-width: 1200px) {
  .pc-ctrl {
    display: flex;
  }

  .mobile-ctrl {
    display: none;
  }
}

@media (max-width: 576px) {
  .pc-ctrl {
    display: none;
  }

  .mobile-ctrl {
    display: flex;
  }

  .teleport-day {
    width: 50%;
  }
}
</style>
<script>
import { Component, Vue, Watch } from "vue-property-decorator";
import { mapState } from "vuex";
import StarRating from "vue-star-rating";
import MainWrapper from "@/wrappers/MainWrapper.vue";
import Button from "@/components/Button.vue";
import Schedule from "@/components/Schedule.vue";
import ScheduleAdmin from "@/components/ScheduleAdmin.vue";
import RatingStar from "@/components/RatingStar";
import Paginator from "@/components/Paginator";

import moment from "moment";

import http from "@/methods/http.ts";

@Component({
  components: {
    MainWrapper,
    Button,
    Schedule,
    ScheduleAdmin,
    RatingStar,
    StarRating,
    Paginator,
  },
  filters: {
    rating(value) {
      return value.toFixed(1);
    },
  },
  computed: mapState(["authenticated", "profile"]),
})
export default class SingleMaster extends Vue {
  tab = 1;

  specModal = false;

  todayDay = moment().format("YYYY-MM-DD");
  teleportDay = moment().format("YYYY-MM-DD");
  firstDay = moment().format("DD.MM.YYYY");

  specReviews = [];
  comment = "";

  specInfo = {
    rating: 0,
    categories: [],
    opened_now: false,
  };

  zcolors = [];
  colors = ["#2F80ED", "#F2C94C", "#ddd", "#eee"];
  isVisible = false;

  workQualityTitle = "Качество обслуживания";
  serviceQualityTitle = "Ценовая политика";
  paymentQualityTitle = "Компетентность специалиста";

  rateState = {
    overall: 0,
    work: {
      set: false,
      value: 0,
      rating: 0,
      isEmpty: false,
    },
    service: {
      set: false,
      value: 0,
      rating: 0,
      isEmpty: false,
    },
    payment: {
      set: false,
      value: 0,
      rating: 0,
      isEmpty: false,
    },
  };

  total = 0;
  pages = 0;
  page = 1;
  itemPerPage = 5;

  @Watch("page", { deep: true, immediate: true })
  onPageChange() {
    this.getSpecReviews();
  }

  get isCurrentUser() {
    return (
      this.authenticated &&
      this.$route.params.slug === this.profile.specialist_slug
    );
  }

  nextDay() {
    this.firstDay = moment(this.firstDay, "DD.MM.YYYY")
      .add(1, "d")
      .format("DD.MM.YYYY");

    let myDate = this.firstDay;
    myDate = myDate.split(".");
    this.teleportDay = myDate[2] + "-" + myDate[1] + "-" + myDate[0];
  }
  prevDay() {
    this.firstDay = moment(this.firstDay, "DD.MM.YYYY")
      .subtract(1, "d")
      .format("DD.MM.YYYY");

    let myDate = this.firstDay;
    myDate = myDate.split(".");
    this.teleportDay = myDate[2] + "-" + myDate[1] + "-" + myDate[0];
  }

  nextWeek() {
    this.firstDay = moment(this.firstDay, "DD.MM.YYYY")
      .add(7, "d")
      .format("DD.MM.YYYY");

    let myDate = this.firstDay;
    myDate = myDate.split(".");
    this.teleportDay = myDate[2] + "-" + myDate[1] + "-" + myDate[0];
  }

  prevWeek() {
    /*
      var myDate = this.firstDay;
      myDate = myDate.split(".");
      var newDate = myDate[1]+"/"+myDate[0]+"/"+myDate[2];
      var stepDay = Math.floor(new Date(newDate).getTime() / 1000);
      var myDate = moment().format("DD.MM.YYYY");
      myDate = myDate.split(".");
      var newDate = myDate[1]+"/"+myDate[0]+"/"+myDate[2];
      var todayDay = Math.floor(new Date(newDate).getTime() / 1000);

      if (stepDay <= todayDay) {
          return false;
      }
      */
    this.firstDay = moment(this.firstDay, "DD.MM.YYYY")
      .subtract(7, "d")
      .format("DD.MM.YYYY");

    let myDate = this.firstDay;
    myDate = myDate.split(".");
    this.teleportDay = myDate[2] + "-" + myDate[1] + "-" + myDate[0];
  }

  teleportSetTime() {
    var myDate = this.teleportDay.split("-");
    this.firstDay = myDate[2] + "." + myDate[1] + "." + myDate[0];
  }

  getSpecInfo() {
    http(`masters/${this.$route.params.slug}`, "get", false, {}).then((r) => {
      console.group("getSpecInfo");
      console.log(r.data);
      console.groupEnd();
      this.specInfo = r.data;
      let owner_colors = [];
      let color_palette = this.colors;
      let i = 0;
      if (this.specInfo.company) {
        this.specInfo.company.forEach(function (element) {
          owner_colors[element.owner] = color_palette[i];
          i++;
        });
        this.zcolors = owner_colors;
      }
    });
  }

  getSpecReviews() {
    moment.lang("ru");
    let review_list = [];
    http(`masters/${this.$route.params.slug}/rating`, "get", false, {
      page: this.page,
      limit: this.itemPerPage,
    }).then((r) => {
      console.log("reviews", r);
      this.total = r.data.total;
      review_list = r.data.list;
      if (review_list.length > 0) {
        review_list.forEach(function (elm) {
          elm.created_at = moment
            .unix(parseInt(elm.date))
            .format("DD MMMM YYYY");
        });
      }
      console.log("review_list", review_list);
      this.pages = Math.ceil(r.data.total / this.itemPerPage);
      this.specReviews = review_list;
    });
  }

  setComment() {
    if (this.comment === "") {
      this.$store.commit("notificate", {
        text: "Напишите отзыв",
        type: "error",
      });
      return false;
    } else if (this.rateState.overall === 0) {
      this.$store.commit("notificate", {
        text: "Поставьте оценки",
        type: "error",
      });
      return false;
    }
    http("masters/rating/create", "post", this.$store.state.token, {
      master_id: this.specInfo.user,
      message: this.comment,
      rating: this.rateState.overall,
    })
      .then((r) => {
        this.comment = "";
        this.$store.commit("notificate", {
          text: "Отзыв добавлен",
          type: "action",
        });
        this.clearRating();
      })
      .catch((r) => {
        this.$store.commit("notificate", {
          text: "Введены неверные данные",
          type: "error",
        });
      });
  }

  getSchedule() {
    let orgs = this.specInfo.company;
    let orgs_list = [];
    orgs_list.push("-1");
    for (let key in orgs) {
      if (orgs[key].checked === true) {
        orgs_list.push(orgs[key].id);
      }
    }
    http(`masters/${this.$route.params.slug}/schedule/beta`, "get", false, {
      day: this.firstDay,
      day_count: 7,
      orgs: orgs_list,
    }).then((r) => {
      if (r.data.length) {
        this.isVisible = true;
      }
    });
  }

  workQualityHandler({ majorRating, rating }) {
    const type = "work";
    this.calculateRate(majorRating, type);
    this.rateState[type].set = true;
    this.rateState[type].value = majorRating;
    this.rateState[type].rating = rating;
  }

  serviceQualityHandler({ majorRating, rating }) {
    const type = "service";
    this.calculateRate(majorRating, type);
    this.rateState[type].set = true;
    this.rateState[type].value = majorRating;
    this.rateState[type].rating = rating;
  }

  paymentQualityHandler({ majorRating, rating }) {
    const type = "payment";
    this.calculateRate(majorRating, type);
    this.rateState[type].set = true;
    this.rateState[type].value = majorRating;
    this.rateState[type].rating = rating;
  }

  calculateRate(rate, type) {
    if (this.rateState[type].set) {
      this.rateState.overall -= this.rateState[type].value;
      this.rateState.overall += rate;
    } else {
      this.rateState.overall += rate;
    }
    console.group("RATE");
    console.log(this.rateState);
    console.groupEnd();
  }

  clearRating() {
    Object.keys(this.rateState).map((k) => {
      if (k !== "overall") {
        this.rateState[k].isEmpty = true;
        this.rateState[k].rating = 0;
      }
    });
    console.log("rateState", this.rateState);
  }

  changePage(p) {
    this.page = p;
  }

  mounted() {
    this.getSpecInfo();
    this.getSpecReviews();
    this.getSchedule();
  }
}
</script>